import { isServiceScriptFile } from '../../utils/is-service-script-file';

/**
 * Builds the list of script names to pass to the PIF compiler validator.
 *
 * Extracts uploaded script names from `draft.files` (entries under `services/`),
 * strips the file extension so they match the command names used in action nodes,
 * and merges them with the provided default (built-in) functions.
 *
 * Result shape: ["AssignVariable", "SendEmail", "SysMultiMatchRouting", ...]
 */
export function buildScriptFileNames(
  draftFiles: string[],
  defaultFunctions: readonly string[]
): string[] {
  const uploadedNames = draftFiles.filter(isServiceScriptFile).map((file) => {
    const filename = file.split('/').pop() ?? file;
    return filename.replace(/\.[^.]+$/, '');
  });

  return [...uploadedNames, ...defaultFunctions];
}
